var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgupload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1305_4856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.12695 6.1875C7.12695 6.63505 6.93929 7.06428 6.60524 7.38074C6.27119 7.69721 5.81812 7.875 5.3457 7.875C4.87329 7.875 4.42022 7.69721 4.08617 7.38074C3.75212 7.06428 3.56445 6.63505 3.56445 6.1875C3.56445 5.73995 3.75212 5.31072 4.08617 4.99426C4.42022 4.67779 4.87329 4.5 5.3457 4.5C5.81812 4.5 6.27119 4.67779 6.60524 4.99426C6.93929 5.31072 7.12695 5.73995 7.12695 6.1875Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.37695 1.125C1.74706 1.125 1.14297 1.36205 0.697575 1.78401C0.252176 2.20597 0.00195313 2.77826 0.00195312 3.375V14.625C0.00195313 15.2217 0.252176 15.794 0.697575 16.216C1.14297 16.6379 1.74706 16.875 2.37695 16.875H16.627C17.2568 16.875 17.8609 16.6379 18.3063 16.216C18.7517 15.794 19.002 15.2217 19.002 14.625V3.375C19.002 2.77826 18.7517 2.20597 18.3063 1.78401C17.8609 1.36205 17.2568 1.125 16.627 1.125H2.37695ZM16.627 2.25C16.9419 2.25 17.2439 2.36853 17.4666 2.5795C17.6893 2.79048 17.8145 3.07663 17.8145 3.375V10.6875L13.3293 8.49713C13.2179 8.44428 13.0918 8.42594 12.9689 8.44472C12.8459 8.4635 12.7323 8.51843 12.6441 8.60175L8.23845 12.7755L5.0797 10.782C4.96566 10.7101 4.82886 10.6777 4.69251 10.6904C4.55615 10.7031 4.42864 10.7601 4.33158 10.8517L1.18945 13.5V3.375C1.18945 3.07663 1.31456 2.79048 1.53726 2.5795C1.75996 2.36853 2.06201 2.25 2.37695 2.25H16.627Z",
    fill: "#989898"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1305_4856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgupload);
export default __webpack_public_path__ + "static/media/imgupload.35d4e2c2c64d98898e4f89976ae87a9e.svg";
export { ForwardRef as ReactComponent };